import { useFormContext } from 'react-hook-form';
import React, { useContext } from 'react';
import { Button } from 'semantic-ui-react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useModal } from 'store/modals';
import { UserAdministrationModalContext } from '../../../../../UserAdministrationModalContext';
import { discardChangesOnCancel } from '../../../../discardChangesOnCancel';
import styles from './styles.module.scss';

export const FormActions = ({ isLoading, onSubmit }) => {

  const intl = useIntl();
  const modal = useModal();
  const formContext = useFormContext();
  const { formState } = formContext;
  const userAdministrationContext = useContext(UserAdministrationModalContext);

  return (
    <div className={styles.actionContainer}>
      <Button
        basic
        name="cancel-add-user"
        type="button"
        disabled={isLoading}
        onClick={() => discardChangesOnCancel(intl, userAdministrationContext, modal)}
      >
        <FormattedMessage id="cancel" />
      </Button>
      <Button
        primary
        type="submit"
        name="submit-add-user"
        disabled={!formState.isDirty || isLoading}
        loading={isLoading}
        onClick={formContext.handleSubmit(onSubmit)}
      >
        <FormattedMessage id="addUser" />
      </Button>
    </div>
  );
};
